import type { VideoTimeline, VideoTimelineEntry } from '@chatsdet/types';
import type { ExploratoryTestAction } from '../../../features/exploratory-tests/types';

/**
 * Build a VideoTimeline from action audit log entries as a fallback when
 * videoTimelineJson is not persisted (runs before the migration).
 */
export function buildTimelineFromActions(
  actions: ExploratoryTestAction[],
  sessionStartTime: string | null
): VideoTimeline | null {
  if (actions.length === 0) return null;

  const startTime = sessionStartTime
    ? new Date(sessionStartTime).getTime()
    : new Date(actions[0].timestamp).getTime();

  const entries: VideoTimelineEntry[] = actions.map((action) => ({
    action: action.actionType,
    target: action.elementDescription ?? undefined,
    success: action.success ?? true,
    error: action.errorMessage ?? undefined,
    timestampMs: Math.max(0, new Date(action.timestamp).getTime() - startTime),
    isoTimestamp: action.timestamp,
  }));

  return {
    startTimestamp: new Date(startTime).toISOString(),
    entries,
  };
}
